import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

// Sæt app element for react-modal (hvis du ikke allerede har gjort det i App.js)
Modal.setAppElement('#root');

const initialFormStateOrg = { navn: '' };

function OrganisationerListe() {
  const [organisationer, setOrganisationer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formState, setFormState] = useState(initialFormStateOrg);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalError, setModalError] = useState(null); // Fejl specifikt for modalen

  const API_BASE_URL_ORGANISATIONER = `${process.env.REACT_APP_API_URL}/api/organisationer`;

  const openModal = () => { setFormState(initialFormStateOrg); setModalError(null); setModalIsOpen(true); };
  const closeModal = () => { setModalIsOpen(false); setModalError(null); };

  const fetchOrganisationer = async () => {
    setLoading(true); setError(null);
    try {
      // Rettelse #1
      const response = await fetch(API_BASE_URL_ORGANISATIONER, { credentials: 'include' });
      if (!response.ok) throw new Error(`Organisationer: ${response.statusText || response.status}`);
      const data = await response.json();
      setOrganisationer(data);
    } catch (err) {
      console.error("Fejl hentning Organisationer:", err); setError(err.message);
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchOrganisationer(); }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormState(prevState => ({ ...prevState, [name]: value }));
  };

  const handleOrganisationSubmit = async (event) => {
    event.preventDefault(); setModalError(null);
    if (!formState.navn.trim()) { setModalError('Navn er påkrævet.'); return; }

    const submitButton = event.target.querySelector('button[type="submit"]');
    if(submitButton) submitButton.disabled = true;

    try {
      // Rettelse #2
      const response = await fetch(API_BASE_URL_ORGANISATIONER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ navn: formState.navn.trim() }),
        credentials: 'include'
      });
      if (!response.ok) { const errorText = await response.text(); throw new Error(errorText || `Serverfejl: ${response.status}`);}
      
      closeModal();
      fetchOrganisationer(); // Re-fetch for at opdatere listen
    } catch (error) {
      console.error("Fejl gemning af organisation:", error); setModalError(`Kunne ikke gemme: ${error.message}`);
    } finally {
        if(submitButton) submitButton.disabled = false;
    }
  };

  const handleDeleteOrganisation = async (idToDelete) => {
    if (!window.confirm(`Slet organisation med ID ${idToDelete}?`)) return;
    setError(null); setLoading(true);
    try {
      // Rettelse #3
      const response = await fetch(`${API_BASE_URL_ORGANISATIONER}/${idToDelete}`, {
        method: 'DELETE',
        credentials: 'include'
      });
      if (!response.ok && response.status !== 204) { const errorText = await response.text(); throw new Error(errorText || `Serverfejl: ${response.status}`);}
      
      fetchOrganisationer(); // Re-fetch for at opdatere listen
    } catch (error) {
      console.error("Fejl sletning organisation:", error); setError(`Kunne ikke slette: ${error.message}`);
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="toggle-form-container"> {/* I dit eksempel var dette toggle-form-container */}
        <button onClick={openModal} className="toggle-form-button primary-action">Tilføj Ny Organisation</button>
      </div>

      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Tilføj Organisation" className="ReactModal__Content" overlayClassName="ReactModal__Overlay">
        <form onSubmit={handleOrganisationSubmit} className="modal-form">
          <h3>Tilføj Ny Organisation</h3>
          {modalError && <p className="error-message" style={{marginBottom: '15px'}}>{modalError}</p>}
          <div className="form-field">
            <label htmlFor="navnModalOrg">Navn:*</label>
            <input type="text" id="navnModalOrg" name="navn" value={formState.navn} onChange={handleInputChange} required />
          </div>
          <div className="modal-actions">
            <button type="submit">Gem Organisation</button>
            <button type="button" onClick={closeModal} className="cancel-button">Annuller</button>
          </div>
        </form>
      </Modal>

      {error && !modalIsOpen && <p className="error-message">{error}</p>}
      <h2>Eksisterende Organisationer</h2>
      {loading && <p className="info-message">Henter organisationer...</p>}
      {!loading && organisationer.length === 0 && !error && (<p className="info-message">Ingen organisationer fundet.</p>)}
      {!loading && organisationer.length > 0 && (
        <div className="table-container">
          <table className="censor-table">
            <thead><tr><th>ID</th><th>Navn</th><th className="action-cell">Handlinger</th></tr></thead>
            <tbody>
              {organisationer.map(org => (
                <tr key={org.id}>
                  <td>{org.id}</td><td><strong>{org.navn}</strong></td>
                  <td className="action-cell">
                    <button onClick={() => handleDeleteOrganisation(org.id)} className="delete-button icon-button" title={`Slet ${org.navn}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px" className="delete-icon"><path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.9h1.368c1.603 0 2.816 1.336 2.816 2.9zm-1.452.721a.75.75 0 01.216-.534l.018-.018a.75.75 0 01.706-.216L17.5 5.25a.75.75 0 01.216.534l-.018.018a.75.75 0 01-.706.216l-1.281-.214a.75.75 0 01-.216-.534z" clipRule="evenodd" /></svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default OrganisationerListe;